<template>
  <main class="mgc-system">
    <div class="mgc-page"><div class="mgc-form-layout">
      <h1 class="mgc-heading">{{ heading }}</h1>
      <p v-if="mode === 'loading'" role="status">Checking your university sign-in…</p>
      <template v-if="showAccounts">
        <p class="mgc-body">Check that both accounts belong to you. Nothing is linked until you confirm.</p>
        <dl class="mgc-card account-review">
          <dt class="mgc-label">University account</dt>
          <dd>{{ accounts.universityEmail }}</dd>
          <dt class="mgc-label">Existing MGC account</dt>
          <dd>{{ accounts.mgcEmail }}</dd>
        </dl>
        <p class="mgc-body">Your MGC data, access and password will stay the same.</p>
        <div class="mgc-actions">
          <button type="button" class="mgc-button" :disabled="busy" @click="confirm">Confirm connection</button>
          <button type="button" class="mgc-button mgc-button--secondary" :disabled="busy" @click="cancel">Cancel</button>
        </div>
        <p v-if="busy" class="mgc-help" role="status">{{ mode === 'saving' ? 'Saving your connection…' : 'Cancelling this connection attempt…' }}</p>
        <p class="account-hint mgc-body">Not your university account? Cancel, sign out of that university account in this browser, then try again.</p>
      </template>
      <p v-if="mode === 'error'" role="alert">{{ error }}</p>
      <template v-if="mode === 'connected'">
        <p>Your existing MGC account is now connected. Your data, permissions and password settings have not changed.</p>
        <p>Next time, choose “Sign in with your organisation” and enter your university or work email.</p>
      </template>
      <p v-if="mode === 'cancelled'">No account link was saved by this attempt. You can keep using your existing MGC sign-in.</p>
      <router-link v-if="mode === 'error' || mode === 'cancelled' || mode === 'connected'" class="mgc-link back-link" :to="mode === 'connected' ? '/admin/choose' : '/admin/account/sign-in'">{{ mode === 'connected' ? 'Continue to MGC' : 'Return to account settings' }}</router-link>
    </div></div>
  </main>
</template>
<script>
import { prepareLink, confirmLink, cancelLink } from '../../api/selfServiceLink';
import '../../styles/mgc-system.css';
export default {
  data: () => ({ mode: 'loading', accounts: {}, error: '', uncertain: false }),
  computed: {
    busy() { return this.mode === 'saving' || this.mode === 'cancelling'; },
    showAccounts() { return this.mode === 'review' || this.busy; },
    heading() {
      if (this.mode === 'loading') return 'Checking university sign-in';
      if (this.mode === 'connected') return 'University sign-in connected';
      if (this.mode === 'cancelled') return 'Connection cancelled';
      if (this.mode === 'error') return this.uncertain ? 'Check your connection' : 'Connection not completed';
      return 'Confirm your university account';
    },
  },
  async mounted() {
    try {
      const data = await prepareLink();
      if (data.linked === true) { this.mode = 'connected'; return; }
      if (!data.confirmationRequired || !data.universityEmail || !data.mgcEmail) throw new Error('The accounts could not be checked. Return to settings and start again.');
      this.accounts = data;
      this.mode = 'review';
    } catch (error) { this.failed(error); }
  },
  methods: {
    failed(error) {
      this.uncertain = error.code !== 'LINK_INTERRUPTED' && (!error.response || error.response.status >= 500);
      this.error = this.uncertain
        ? 'We could not confirm the connection status. Open account settings to check. Your existing login still works.'
        : error.response?.data?.error || error.message || 'Return to your account settings to check your connection.';
      this.mode = 'error';
    },
    async confirm() {
      if (this.mode !== 'review') return;
      this.mode = 'saving';
      try { await confirmLink(); this.mode = 'connected'; }
      catch (error) { this.failed(error); }
    },
    async cancel() {
      if (this.mode !== 'review') return;
      this.mode = 'cancelling';
      try { await cancelLink(); this.mode = 'cancelled'; }
      catch (error) { this.failed(error); }
    },
  },
};
</script>
<style scoped>
.account-review { margin: 24px 0; }
.account-review dd { margin: 0; overflow-wrap: anywhere; font-weight: 800; }
.account-review dt:not(:first-child) { margin-top: 24px; }
.account-hint { margin-top: 24px; }
.back-link { display: inline-block; margin-top: 24px; padding: 12px 0; }
</style>
